<template>
  <v-card class="py-2 text-center" color="white" width="auto" elevation="0" style="height:1350px">
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="back" color="back" text @click="closeModal()">
        <v-icon color="#ba0009">mdi-close</v-icon>
      </v-btn>
    </v-card-actions>
    <h3 class="my-2" style="font-family:mplus-2c-light;">じっくり話して、しっかり決める。</h3>
    <v-img src="../../assets/png/Liqlid_icon_logo-shrinked.png" width="60%" class="my-6 mx-auto"></v-img>
    <!--通知-->
    <v-card color="#CCE8FF" class="my-4" align="center" elevation="0">
      <v-card-text v-if="resign === 'set'" class="font-weight-black">メールアドレスの確認が完了しました<br>もう一度ログインしてください</v-card-text>
      <v-card-text v-if="resign === 'reset'" class="font-weight-black">パスワードの再設定が完了しました<br>新しいパスワードでログインしてください</v-card-text>
    </v-card>
    <!--Error-->
    <div class="text-center">
      <p v-if="errorMessage=='errorAccountDisabled'">アカウントが存在しません<br>管理者にお問い合わせください</p>
      <p v-if="errorMessage=='errorNoAccount'">アカウントが作成されていません<br><router-link to="/signup">ここをクリックしてアカウントを作成</router-link></p>
      <p v-if="errorMessage=='aller'">全ての項目を<br>正しく入力してください</p>
      <p v-if="errorMessage=='errorEmailInValid'">メールアドレスの形式が違います<br>もう一度正しく入力してください</p>
      <p v-if="errorMessage=='errorPasswordInvalid'">パスワードが違います<br>もう一度正しく入力してください</p>
      <p v-if="errorMessage=='errorEmailNotVerified'" class="font-weight-black">メールアドレスを確認する必要があります。<br>認証メールを送信いたしましたのでご確認ください。</p>
      <p v-if="errorMessage=='errorUnknown'" class="font-weight-black">不明なエラーが発生しました。時間をおいて再度お試しください。</p>
    </div>
    <!--入力フォーム-->
    <v-form class="px-12">
      <!-- <p class="">メールアドレス</p> -->
      <v-text-field
        v-model="email"
        :rules="[rules.mailrequired, rules.email]"
        placeholder="メールアドレスを入力"
        rounded
        outlined
      ></v-text-field>             
      <!-- <p class="">パスワード</p> -->
      <v-text-field 
        v-model="password"
        :rules="[rules.passrequired, rules.min]"
        placeholder="パスワードを入力"
        rounded
        outlined
        :type="'password'"
      ></v-text-field>
    </v-form>

    <!--CheckBox-->
    <div class="d-flex justify-center">
      <v-checkbox class="" v-model="checkbox" label="次回から自動でログイン"></v-checkbox>
    </div>
    
    <!--LoginBtn-->
    <!--TODO: 処理中にボタンを押せないようにする-->
    <v-btn v-if="(password.length > 7 && email) && !loading" class="rounded-pill px-10" @click="reseterr(),login()" color="#008cff" dark
      style="text-transform: none; font-family: mplus-2c-bold; font-size: 20px;">
      ログイン
    </v-btn>
    <v-btn v-else-if="!loading" color="#707070" class="rounded-pill px-10" dark style="text-transform: none; font-family: mplus-2c-bold; font-size: 20px;">ログイン</v-btn>
    <v-btn v-else class="rounded-pill px-10" color="#008cff" dark
      style="text-transform: none; font-family: mplus-2c-bold; font-size: 20px;">
      <v-progress-circular indeterminate color="white" size="20"></v-progress-circular>
    </v-btn>
  
    <div class="d-flex justify-center flex-column mt-5">
      <!--ForgotPassword-->
      <v-btn text @click="changeView('passwordreset')" class="">
        パスワードを忘れた方へ
      </v-btn>
      <router-link to="/signup" class="text-decoration-none">
        <v-btn text class="">
          アカウントを作成
        </v-btn>
      </router-link>
    </div>

     <!--戻るボタン-->
    <div class="mt-2">
      <v-btn class="back" color="back" text @click="changeView('chooseauth')">
        <span style="color:#008CFF">＜</span> &nbsp; &nbsp;戻る &nbsp; &nbsp;<span style="color:#008CFF">＞</span>
      </v-btn>
    </div>
  </v-card>
</template>

<script>
import firebase from 'firebase'
import Vue from 'vue'
import Toasted from "vue-toasted";
Vue.use(Toasted,{iconPack : 'material'})
export default {
  components: {
  },
  data () {
    return {
      email: '',
      password: '',
      checkbox: true,
      show1: false,
      rules: {
        mailrequired: value => !!value || 'メールアドレスを入力してください',
        passrequired: value => !!value || 'パスワードを入力してください',
        email: value => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value) || 'メールアドレスを正しく入力してください',
        min: value => value.length >= 8 || '8文字以上で入力してください'
      },
      errorMessage: '',
      errorAccountDisabled: false,
      errorNoAccount: false,
      aller: false,// 要らない...？
      errorEmailInValid: false,
      errorPasswordInvalid: false,
      resign: this.$route.query.id,/*reset or set*/
      loading: false
    }
  },
  methods: {
    reseterr(){
      this.errorMessage = '',
      this.errorPasswordInvalid = false,
      this.errorEmailInValid = false,
      this.errorAccountDisabled = false,
      this.errorNoAccount = false,
      this.aller = false
    },
    created: function() {
    },
    showToast(message="エラーが発生しました"){
      this.$toasted.show(message, {
        theme: "bubble", 
        position: "bottom-center", 
        duration : 5000,
      });
    },
    login: async function () {
      this.errorMessage = ''
      this.loading = true
      var self = this
      const res = await this.$store.dispatch('auth/signInWithEmailAndPassword', { email: this.email, password: this.password, checkForPersist: this.checkbox });
      //console.log(res)
      if (res.success) {
        this.redirect()
      } else {
        this.loading = false
        
      //   <p v-if="errorMessage=='errorAccountDisabled'">アカウントが存在しません<br>管理者にお問い合わせください</p>
      // <p v-if="errorMessage=='errorNoAccount'">アカウントが作成されていません<br><router-link to="/signup">ここをクリックしてアカウントを作成</router-link></p>
      // <p v-if="errorMessage=='aller'">全ての項目を<br>正しく入力してください</p>
      // <p v-if="errorMessage=='errorEmailInValid'">メールアドレスの形式が違います<br>もう一度正しく入力してください</p>
      // <p v-if="errorMessage=='errorPasswordInvalid'">パスワードが違います<br>もう一度正しく入力してください</p>
      // <p v-if="errorMessage=='errorEmailNotVerified'" class="font-weight-black">メールアドレスを確認する必要があります。<br>認証メールを送信いたしましたのでご確認ください。</p>
      // <p v-if="errorMessage=='errorUnknown'" class="font-weight-black">不明なエラーが発生しました。時間をおいて再度お試しください。</p>
    
        this.errorMessage = res.message
        let toastMessage = ''
        switch (res.message) {
          case 'errorAccountDisabled':
            toastMessage = 'アカウントが存在しません。管理者にお問い合わせください。'
            break;
          case 'errorNoAccount':
            toastMessage = 'アカウントが作成されていません。'
            break;
          case 'aller':
            toastMessage = '全ての項目を正しく入力してください。'
            break;
          case 'errorEmailInValid':
            toastMessage = 'メールアドレスの形式が違います。もう一度正しく入力してください。'
            break;
          case 'errorPasswordInvalid':
            toastMessage = 'パスワードが違います。もう一度正しく入力してください。'
            break;
          case 'errorEmailNotVerified':
            toastMessage = 'メールアドレスを確認する必要があります。認証メールを送信いたしましたのでご確認ください。'
            break;
          case 'errorUnknown':
            toastMessage = '不明なエラーが発生しました。時間をおいて再度お試しください。'
            break;
          default:
            toastMessage = 'エラーが発生しました。時間をおいて再度お試しください。'
            break;
        }
        
        this.showToast(toastMessage)
      }
    },
    redirect() {
      const self = this
      // User is signed in. 
      self.closeModal()
    },
    closeModal(){
      this.$emit('closeModal')
    },
    changeView(view){
      this.$emit('changeView', view)
    },
  },
  mounted(){
    this.reseterr()
  }
}
</script>